import { DatePicker as AntdDatePicker } from "antd";
import React from "react";

export type MyDatePickerProps = React.ComponentProps<typeof AntdDatePicker>;

export interface DatePickerStaticMethods {
  RangePicker: typeof AntdDatePicker.RangePicker;
  MonthPicker: typeof AntdDatePicker.MonthPicker;
}

const DatePicker = React.forwardRef<any, MyDatePickerProps>((props, ref) => {
  return <AntdDatePicker ref={ref} {...props} />;
}) as React.ForwardRefExoticComponent<
  MyDatePickerProps & React.RefAttributes<any>
> &
  DatePickerStaticMethods;

DatePicker.RangePicker = AntdDatePicker.RangePicker;
DatePicker.MonthPicker = AntdDatePicker.MonthPicker;

export default DatePicker;
